module.exports = __webpack_public_path__ + "static/media/ovalle.ea4f40fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/andimar/destinations/ovalle.png
// module id = 1172
// module chunks = 0